import WorkspaceSettingsIcon from '@/components/icons/settings/WorkspaceSettingsIcon.vue'
import AccountDetailsIcon from '@/components/icons/settings/AccountDetailsIcon.vue'
import SecuritySettingsIcon from '@/components/icons/settings/SecuritySettingsIcon.vue'
import NotificationSettingsIcon from '@/components/icons/settings/NotificationSettingsIcon.vue'
import LoginHistoryIcon from '@/components/icons/settings/LoginHistoryIcon.vue'
import ApiKeysIcon from '@/components/icons/settings/ApiKeysIcon.vue'
import WorkspaceActivityIcon from '@/components/icons/settings/WorkspaceActivityIcon.vue'
import WhiteLabelIcon from '@/components/icons/settings/WhiteLabelIcon.vue'
import ManageBillingIcon from '@/components/icons/settings/ManageBillingIcon.vue'
import RatesExpensesIcon from '@/components/icons/settings/RatesExpensesIcon.vue'

import { ROUTES } from '@/constants/routes'
import { ROUTER_PARAMS_NAMES } from '@/constants/routerParamsNames'
import { SETTINGS_VISIBILITY } from '@/constants/settingsVisibility'

const ACCOUNT = ROUTER_PARAMS_NAMES.account
const WORKSPACE = ROUTER_PARAMS_NAMES.workspace

const SETTINGS_WORKSPACE_ITEMS = [
    {
        id: 1,
        name: 'Workspace Settings',
        routeName: ROUTES.manageWorkspace,
        paramsNames: [ACCOUNT, WORKSPACE],
        icon: () => WorkspaceSettingsIcon,
        visible: SETTINGS_VISIBILITY.workspaceOwner,
    },
    {
        id: 2,
        name: 'Workspace Activity',
        routeName: ROUTES.workspaceActivity,
        paramsNames: [WORKSPACE],
        icon: () => WorkspaceActivityIcon,
        visible: SETTINGS_VISIBILITY.workspaceOwner,
    },
]

const SETTINGS_ACCOUNT_ITEMS = [
    {
        id: 3,
        name: 'Account Details',
        routeName: ROUTES.accountDetails,
        paramsNames: [],
        icon: () => AccountDetailsIcon,
    },
    {
        id: 4,
        name: 'Security Settings',
        routeName: ROUTES.securitySettings,
        icon: () => SecuritySettingsIcon,
    },
    {
        id: 5,
        name: 'Notification Settings',
        routeName: ROUTES.notificationSettings,
        icon: () => NotificationSettingsIcon,
    },
    {
        id: 6,
        name: 'Login History',
        routeName: ROUTES.loginSecurity,
        icon: () => LoginHistoryIcon,
    },
    {
        id: 7,
        name: 'Api Keys',
        routeName: ROUTES.apiAccessTokens,
        paramsNames: [ACCOUNT],
        icon: () => ApiKeysIcon,
        visible: SETTINGS_VISIBILITY.hasAccount,
    },
    {
        id: 8,
        name: 'White Label',
        routeName: ROUTES.whiteLabel,
        paramsNames: [ACCOUNT],
        icon: () => WhiteLabelIcon,
        visible: SETTINGS_VISIBILITY.whiteLabel,
    },
]

const SETTINGS_BILLING_ITEMS = [
    {
        id: 9,
        name: 'Manage Billing',
        routeName: ROUTES.manageBilling,
        paramsNames: [WORKSPACE],
        icon: () => ManageBillingIcon,
        visible: SETTINGS_VISIBILITY.manageBilling,
    },
    {
        id: 10,
        name: 'Rates and Expenses',
        routeName: ROUTES.ratesExpenses,
        paramsNames: [ACCOUNT],
        icon: () => RatesExpensesIcon,
        visible: SETTINGS_VISIBILITY.workspaceOwner,
    },
]

export const SETTINGS_MENU_GROUPS = [
    {
        id: 'workspace',
        section: 'Workspace Settings',
        items: SETTINGS_WORKSPACE_ITEMS,
    },
    {
        id: 'account',
        section: 'Account Settings',
        items: SETTINGS_ACCOUNT_ITEMS,
    },
    {
        id: 'billing',
        section: 'Billing Settings',
        items: SETTINGS_BILLING_ITEMS,
    },
]

export const SETTINGS_ROUTE_REFERENCES = [
    ROUTES.manageWorkspace,
    ROUTES.accountDetails,
    ROUTES.securitySettings,
    ROUTES.notificationSettings,
    ROUTES.loginSecurity,
    ROUTES.apiAccessTokens,
    ROUTES.workspaceActivity,
    ROUTES.whiteLabel,
    ROUTES.manageBilling,
    ROUTES.ratesExpenses,
]
